import React from 'react';
import PropTypes from 'prop-types';
import { 
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter } from 'shards-react';

const ModalConfirm = (props) => {
  return (
    <Modal
          open={props.show}
          toggle={props.onHide}
        >
          {
            props.titleHeader && (
              <ModalHeader>{props.titleHeader}</ModalHeader>
            )
          }
          <ModalBody>
            {
              props.children
            }
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              theme="secondary"
              onClick={props.onPressButtonCancel}
            >
              {" "}
              ยกเลิก{" "}
            </Button>
            <Button
              theme="success"
              onClick={props.onPressButtonConfirm}
            >
              ยืนยัน
            </Button>
          </ModalFooter>
        </Modal>
  )
}

ModalConfirm.propTypes = {
  titleHeader: PropTypes.string,
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onPressButtonCancel: PropTypes.func,
  onPressButtonConfirm: PropTypes.func,
  children: PropTypes.node,
};

ModalConfirm.defaultProps = {
  titleHeader: '',
  show: false,
};

export default ModalConfirm;